<template>
<div>
    <v-row justify="center">
        <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :return-value.sync="date_value" transition="scale-transition" offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="date_value" :label="title" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="date_value" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu = false">
                    Cancel
                </v-btn>
                <v-btn text color="primary" @click="$refs.menu.save(date_value)">
                    OK
                </v-btn>
            </v-date-picker>
        </v-menu>
    </v-row>
</div>
</template>

<script>
export default {

    props: {
        value: null,
        title:null
    },

    data: () => ({
        menu: null,
        date_value: null

    }),

    computed: {

    },

    watch: {
        value() {
  this.date_value = this.value
        },

        date_value(){
              this.$emit('setDate', this.date_value)
        }

    },
    created() {
      
    },

};
</script>
